export const MC_FEATURES = [
  {
    title: 'Design & Code Editors',
    tooltip:
      'Create emails using HTML code, drag & drop editing, or a mix of both.',
  },
  {
    title: 'Segmentation',
    tooltip:
      'Target audiences based on your custom field data or our email engagement data.',
  },
  {
    title: 'A/B Testing & Actionable Insights',
    tooltip:
      'Test multiple subject lines and content variations within a single send and access analytics reports to learn from engagement and recipient data.',
  },
  {
    title: {
      free: '3 Email Testing Credits',
      basic: '10 Email Testing Credits',
      advanced: '60 Email Testing Credits',
    },
    tooltip:
      'Run spam tests, preview how your email renders, and validate links within your editing workflow.',
  },
  {
    title: {
      free: '1 Signup Form',
      basic: '5 Signup Forms',
      advanced: '15 Signup Forms',
    },
    tooltip: {
      free:
        'Grow your contact list with a simple signup form you can embed on your website or share as a SendGrid hosted link.',
      basic:
        'Grow your contact list with simple signup forms you can embed on your website or share as Twilio SendGrid hosted links.',
      advanced:
        'Grow your contact list with simple signup forms you can embed on your website or share as Twilio SendGrid hosted links.',
    },
  },
  {
    title: {
      free: 'Ticket Support',
      basic: 'Ticket & Chat Support',
      advanced: 'Guaranteed Response Times on Ticket, Chat, & Phone Support',
    },
    tooltip: {
      free: 'Get help from our expert support team through a web ticket.',
      basic:
        'Get help from our expert support team through a web ticket or live chat.',
      advanced:
        'Get help faster from our expert support team through a web ticket, live chat, or phone call.',
    },
  },
  {
    title: {
      free: '1 Teammate',
      basic: '1 Teammate',
      advanced: '1,000 Teammates',
    },
    tooltip: {
      free:
        'If you want to allow multiple users to send email from the same account, consider upgrading to a paid plan!',
      basic:
        'Allow multiple users to send email from the same account by defining distinct feature access per user.',
      advanced:
        'Allow multiple users to send email from the same account by defining distinct feature access per user.',
    },
  },
  {
    title: {
      free: 'Automation',
      basic: 'No Automation',
      advanced: 'Automation',
    },
    tooltip: {
      free:
        'Send automated emails or time-based drip series using triggers you already have in place.',
      basic:
        'You won’t be able to send automated emails or time-based drip series. Upgrade to an Advanced plan to access automation!',
      advanced:
        'Send automated emails or time-based drip series using triggers you already have in place.',
    },
    exclude: ['basic'],
  },
  {
    title: {
      free: 'No Access to Dedicated IPs',
      basic: 'No Access to Dedicated IPs',
      advanced: 'Dedicated IP Included 🎉',
    },
    tooltip: {
      free:
        'You’ll share an IP with other senders. To own your sender reputation and access to a dedicated IP upgrade to Pro/Advanced.',
      basic:
        'You’ll share an IP with other senders. To own your sender reputation and access to a dedicated IP upgrade to Pro/Advanced.',
      advanced:
        'Own your reputation with a dedicated IP address, and then automate your IP warmup and manage additional IP addresses.',
    },
    exclude: ['free', 'basic'],
  },
];

export const EI_FEATURES = [
  {
    title: {
      free: '1 teammate permission',
      essentials: '1 teammate permission',
      pro: '1,000 teammates permission',
      premier: '1,000 teammates permission',
    },
  },
  {
    title: 'APIs, SMTP Relay',
    tooltip:
      'Optimize your email deliverability at scale on our custom MTA (with a 99.999% uptime, you can count on us!)',
  },
  {
    title: {
      free: '1 Event Webhook',
      essentials: '2 Event Webhooks',
      pro: '5 Event Webhooks',
      premier: '5 Event Webhooks',
    },
    tooltip: 'A powerful way to collect, process, and deliver events in near real-time to your endpoints. Make data driven decisions at your fingertips!'
  },
  {
    title: {
      free: 'Delivery Optimization Tools',
      essentials: 'Delivery Optimization Tools',
      pro: 'Delivery Optimization Tools',
      premier: 'Delivery Optimization Tools',
    },
    tooltip: {
      free:
        'Maximize deliverability with SPF records, custom DKIM, and suppression management.',
      essentials:
        'Maximize deliverability with SPF records, custom DKIM, and suppression management.',
      pro:
        'Maximize your inbox placement with SPF records and custom DKIM, reputation monitoring, and suppression management.',
      premier:
        'Maximize your inbox placement with SPF records and custom DKIM, reputation monitoring, and suppression management.',
    },
  },
  {
    title: {
      free: 'Dynamic Template Editor',
      essentials: 'Dynamic Template Editor',
      pro: 'Dynamic Templates + Testing',
      premier: 'Dynamic Templates + Testing',
    },
    tooltip: {
      free:
        'Send personalized content with real-time design editing, point-to-click HTML rendering, and conditional testing.',
      essentials:
        'Send personalized content with real-time design editing, point-to-click HTML rendering, and conditional testing.',
      pro:
        'Design impactful templates with point-to-click HTML rendering, conditional testing, spam filter analysis, and link validation.',
      premier:
        'Design impactful templates with point-to-click HTML rendering, conditional testing, spam filter analysis, and link validation.',
    },
  },
  {
    title: 'Insightful Analytics',
    tooltip:
      'Access a data-rich activity feed, aggregate statistics, and monitor your sender reputation.',
  },
  {
    title: {
      free: 'Ticket Support',
      essentials: 'Guaranteed Response Times on Ticket & Chat Support',
      pro: 'Guaranteed Response Times on Ticket, Chat, & Phone Support',
      premier: 'Guaranteed Response Times on Ticket, Chat, & Phone Support',
    },
    tooltip: {
      free: 'Get help from our expert support team through a web ticket.',
      essentials:
        'Get help fast from expert support team through a web ticket or live chat.',
      pro:
        'Get help faster from our expert support team through a web ticket, live chat, or phone call.',
      premier:
        'Get help faster from our expert support team through a web ticket, live chat, or phone call.',
    },
  },
    {
    title: 'Deliverability Insights',
    tooltip: 'Gain actionable insights to optimize your email program with the Deliverability Insights dashboard.',
  },
  {
    title: {
      free: 'No Access to Email Validation',
      essentials: 'No Access to Email Validation',
      pro: '2,500 Email Validations',
      premier: '5,000 Email Validations',
    },
    tooltip: {
      free:
        'You won’t be able to protect your sending reputation by validating email addresses before you send.',
      essentials:
        'You won’t be able to protect your sending reputation by validating email addresses before you send.',
      pro:
        'Protect your sending reputation by validating email addresses before sending to them programmatically.',
      premier:
        'Protect your sending reputation by validating email addresses before sending to them programmatically.',
    },
    exclude: ['free', 'essentials'],
  },
  {
    title: {
      free: 'No Access to Dedicated IPs',
      essentials: 'No Access to Dedicated IPs',
      pro: 'Dedicated IP Included 🎉',
      premier: 'Dedicated IP Included 🎉',
    },
    tooltip: {
      free:
        'You’ll share an IP with other senders. To own your sender reputation and access to a dedicated IP upgrade to Pro/Advanced.',
      essentials:
        'You’ll share an IP with other senders. To own your sender reputation and access to a dedicated IP upgrade to Pro/Advanced.',
      pro:
        'Own your reputation with a dedicated IP address, and then automate your IP warmup and manage additional IP addresses.',
      premier:
        'Own your reputation with a dedicated IP address, and then automate your IP warmup and manage additional IP addresses.',
    },
    exclude: ['free', 'essentials'],
  },
  {
    title: {
      free: 'No Subuser Management',
      essentials: 'No Subuser Management',
      pro: 'Subuser Management',
      premier: 'Subuser Management',
    },
    tooltip: {
      free:
        'You won’t be able to segment your sends, assign permissions or credit limits, or view stats programmatically or in the UI.',
      essentials:
        'You won’t be able to segment your sends, assign permissions or credit limits, or view stats programmatically or in the UI.',
      pro:
        'Segment your sending, assign permissions and credit limits, and view separate statistics programmatically or in the UI.',
      premier:
        'Segment your sending, assign permissions and credit limits, and view separate statistics programmatically or in the UI.',
    },
    exclude: ['free', 'essentials'],
  },
  {
    title: {
      free: 'No Single Sign-On (SSO)',
      essentials: 'No Single Sign-On (SSO)',
      pro: 'Single Sign-On (SSO)',
      premier: 'Single Sign-On (SSO)',
    },
    tooltip: {
      free:
        'You won’t be able to Integrate Twilio SendGrid into your established and secure SSO platform to centrally manage user permissions.',
      essentials:
        'You won’t be able to Integrate Twilio SendGrid into your established and secure SSO platform to centrally manage user permissions.',
      pro:
        'Integrate Twilio SendGrid into your established and secure SSO platform to centrally manage user permissions.',
      premier:
        'Integrate Twilio SendGrid into your established and secure SSO platform to centrally manage user permissions.',
    },
    exclude: ['free', 'essentials'],
  },
];
